/* =========================================================================
   Custom Product Landing (Aeris) — behaviour
   Scoped to .clp-* elements only. Idempotent; safe to run multiple times
   and re-inits on Shopify Theme Editor section load events.
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- Countdown timers ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-clp-countdown]').forEach(function (el) {
      if (el.__clpTimer) return;
      var total = parseInt(el.getAttribute('data-seconds'), 10);
      if (isNaN(total) || total <= 0) total = 4 * 3600 + 59 * 60 + 59;
      var loop = parseInt(el.getAttribute('data-loop-seconds'), 10);
      if (isNaN(loop) || loop <= 0) loop = 6 * 3600;
      var hEl = el.querySelector('[data-clp-h]');
      var mEl = el.querySelector('[data-clp-m]');
      var sEl = el.querySelector('[data-clp-s]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var render = function () {
        if (hEl) hEl.textContent = pad(Math.floor(total / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((total % 3600) / 60));
        if (sEl) sEl.textContent = pad(total % 60);
      };
      render();
      el.__clpTimer = setInterval(function () {
        total = total > 0 ? total - 1 : loop;
        render();
      }, 1000);
    });
  }

  /* ---------- Accordions (details + faq) ---------- */
  function onAccordionClick(e) {
    var btn = e.target.closest('.clp-acc__btn');
    if (!btn) return;
    var acc = btn.closest('.clp-acc');
    if (!acc) return;
    var group = acc.getAttribute('data-clp-acc-group');
    var isOpen = acc.classList.contains('is-open');
    if (group) {
      document
        .querySelectorAll('.clp-acc[data-clp-acc-group="' + group + '"]')
        .forEach(function (a) { a.classList.remove('is-open'); });
    }
    if (!isOpen) acc.classList.add('is-open');
    else acc.classList.remove('is-open');
  }

  /* ---------- Product main: offers / variant / price / cart ---------- */
  function initProductMain(root) {
    (root || document).querySelectorAll('[data-clp-main]').forEach(function (main) {
      if (main.__clpInit) return;
      main.__clpInit = true;

      // The {% form 'product' %} tag renders <form class="clp-form">; older builds looked
      // for [data-clp-form] which never existed, so add-to-cart silently no-op'd.
      var form = main.querySelector('[data-clp-form]') || main.querySelector('form.clp-form') || main.querySelector('form[action*="/cart/add"]');
      var idInput = main.querySelector('[data-clp-variant-input]');
      var planInput = main.querySelector('[data-clp-sellingplan-input]');
      var atcBtn = main.querySelector('[data-clp-atc]');
      var atcTotal = main.querySelector('[data-clp-atc-total]');
      var atcReg = main.querySelector('[data-clp-atc-reg]');
      var stickyTotal = main.querySelector('[data-clp-sticky-total]');
      var stickyReg = main.querySelector('[data-clp-sticky-reg]');
      var stickyTitle = main.querySelector('[data-clp-sticky-title]');
      var subToggle = main.querySelector('[data-clp-sub-input]');
      var subWrap = main.querySelector('[data-clp-sub]');
      var qtyInput = main.querySelector('[data-clp-qty-input]');

      function selectedOffer() {
        return main.querySelector('.clp-offer.is-active');
      }

      function applyOffer(offer) {
        if (!offer) return;
        main.querySelectorAll('.clp-offer').forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        offer.classList.add('is-active');
        offer.setAttribute('aria-checked', 'true');

        var vid = offer.getAttribute('data-variant-id');
        var avail = offer.getAttribute('data-available') !== 'false';
        var total = offer.getAttribute('data-total') || '';
        var reg = offer.getAttribute('data-reg') || '';
        var title = offer.getAttribute('data-title') || '';

        if (vid && idInput) idInput.value = vid;
        if (atcTotal) atcTotal.textContent = total;
        if (atcReg) { atcReg.textContent = reg; atcReg.style.display = reg ? '' : 'none'; }
        if (stickyTotal) stickyTotal.textContent = total;
        if (stickyReg) { stickyReg.textContent = reg; stickyReg.style.display = reg ? '' : 'none'; }
        if (stickyTitle) stickyTitle.textContent = title;

        if (atcBtn) {
          if (avail) {
            atcBtn.removeAttribute('disabled');
            if (atcBtn.getAttribute('data-label')) {
              var lbl = atcBtn.querySelector('[data-clp-atc-label]');
              if (lbl) lbl.textContent = atcBtn.getAttribute('data-label');
            }
          } else {
            atcBtn.setAttribute('disabled', 'disabled');
            var lbl2 = atcBtn.querySelector('[data-clp-atc-label]');
            if (lbl2) lbl2.textContent = atcBtn.getAttribute('data-soldout-label') || 'Agotado';
          }
        }
        updateSellingPlan();
      }

      function updateSellingPlan() {
        if (!planInput) return;
        var offer = selectedOffer();
        var on = subToggle && subToggle.checked;
        var plan = offer ? offer.getAttribute('data-selling-plan') : '';
        planInput.value = on && plan ? plan : '';
      }

      main.addEventListener('click', function (e) {
        var offer = e.target.closest('.clp-offer');
        if (offer && main.contains(offer)) { applyOffer(offer); }
      });

      if (subToggle) {
        subToggle.addEventListener('change', function () {
          if (subWrap) subWrap.classList.toggle('is-active', subToggle.checked);
          updateSellingPlan();
        });
      }

      // Quantity stepper
      main.querySelectorAll('[data-clp-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10) || 1;
          v += b.getAttribute('data-clp-qty-btn') === 'up' ? 1 : -1;
          if (v < 1) v = 1;
          qtyInput.value = v;
        });
      });

      // Add to cart (AJAX -> theme cart drawer, graceful fallback)
      function addToCart() {
        if (!form) return;
        var fd = new FormData(form);
        if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (atcBtn) atcBtn.removeAttribute('disabled');
            if (!res.ok) { window.location.href = '/cart'; return; }
            openThemeCart();
          })
          .catch(function () { window.location.href = '/cart'; });
      }

      function openThemeCart() {
        var opened = false;
        // Dawn / Horizon style pub-sub + custom elements
        try {
          if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') { /* noop */ }
        } catch (e) {}
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); opened = true; }
        if (!opened) {
          var notification = document.querySelector('cart-notification');
          if (notification && typeof notification.open === 'function') { notification.open(); opened = true; }
        }
        if (!opened) {
          // Common toggles used by many themes
          var toggle = document.querySelector('[data-cart-drawer-toggle],[aria-controls="CartDrawer"],#cart-icon-bubble,.js-drawer-open-cart,[href="/cart"].cart-link');
          if (toggle) { toggle.click(); opened = true; }
        }
        // Fire generic events that theme/drawer apps (Atlas, Dawn, etc.) listen for
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        if (!opened) { window.location.href = '/cart'; }
      }

      if (atcBtn) atcBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
      var stickyBtn = main.querySelector('[data-clp-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

      // Initial state
      applyOffer(selectedOffer() || main.querySelector('.clp-offer'));
    });
  }

  /* ---------- Gallery thumbs ---------- */
  function initGalleries(root) {
    (root || document).querySelectorAll('[data-clp-gallery]').forEach(function (g) {
      if (g.__clpInit) return;
      g.__clpInit = true;
      var mainImg = g.querySelector('[data-clp-gallery-main]');
      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-clp-thumb]');
        if (!thumb) return;
        g.querySelectorAll('[data-clp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) { mainImg.src = src; mainImg.setAttribute('srcset', ''); }
      });
    });
  }

  /* ---------- Smooth scroll for in-page anchors ---------- */
  function onAnchorClick(e) {
    var a = e.target.closest('[data-clp-scroll]');
    if (!a) return;
    var id = a.getAttribute('data-clp-scroll');
    var target = id && document.getElementById(id);
    if (target) {
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 84, behavior: 'smooth' });
    }
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    initCountdowns(root);
    initProductMain(root);
    initGalleries(root);
  }

  if (!window.__clpDelegation) {
    window.__clpDelegation = true;
    document.addEventListener('click', function (e) {
      onAccordionClick(e);
      onAnchorClick(e);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();